import "./footer.css";
import { Link } from "react-router-dom";
import LazyImage from "../../LazyImg/LazyImage";
import packageInfo from "../../../package.json";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const linkedInIcon = `${digitalOceanURL}/footerImages/linkedIn_icon.svg`;
const footer_bg = `${digitalOceanURL}/FooterAssets/footerBg.svg`;
const facebookIcon = `${digitalOceanURL}/footerImages/facebook_icon.svg`;
const xIcon = `${digitalOceanURL}/footerImages/x_icon.svg`;
const instagramIcon = `${digitalOceanURL}/footerImages/instagram_icon.svg`;
const contactIcon = `${digitalOceanURL}/footerImages/contact_icon.svg`;
const mailIcon = `${digitalOceanURL}/footerImages/mail_icon.svg`;
const locationIcon = `${digitalOceanURL}/footerImages/location_icon.svg`;
const hirestarIcon = `${digitalOceanURL}/footerImages/hirestar_icon.svg`;
export default function Footer() {
  // console.log(`App Version: ${packageInfo.version}`);
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <div>
      <footer className="relative bottom-0 border-t border-opacity-0  border-white footer  ">
        <div
          className="absolute -z-10 inset-0 w-full h-full bg-no-repeat bg-cover bg_center"
          style={{ backgroundImage: `url(${footer_bg})` }}
        />
        {/* z-index-10 */}
        <div className="relative  footer-content-wrapper mx-auto   space-y-8 lg:space-y-8 ">
          {/* center this div */}
          <div className="mx-auto md:mb-[4rem] mb-[2rem] lg:mb-[2rem]  max-w-5xl 2xl:max-w-7xl px-4   ">
            <div className="grid  sm:grid-cols-1 md:grid-col-2 gap-8 lg:grid-cols-3 ">
              <div className="hire-star-left">
                {/* --------logo-------------- */}
                <div className=" text-teal-600 sm:justify-start">
                  <img
                    src={hirestarIcon}
                    alt="footer hirestar Icon"
                    loading="lazy"
                  />
                  {/* src, alt, className  */}
                  {/* <LazyImage src={hirestarIcon} alt="footer hirestar Logo" className={"hirestar-footer-icon"} /> */}
                  <p className="mt-5 opacity-90  text-[14px] text-white max-w-md text-pretty leading-relaxed  sm:max-w-xs sm:text-left">
                    Offer Experience and Employee Background Verification
                    powered by blockchain
                  </p>
                </div>

                {/* Social media links */}
                <div className="text-start follow-us-container lg:mt-6 ">
                  <p className="font-semibold text-base text-white mb-3">
                    Follow Us On
                  </p>
                  <ul className="mt-2 px-0 flex justify-start  sm:justify-start gap-3 md:gap-4 list-none">
                    <li>
                      <a
                        title="LinkedIn"
                        aria-label="Visit HireStar.io LinkedIn Page"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="text-teal-700 transition hover:text-teal-700/75"
                        href="https://in.linkedin.com/showcase/hirestar.io/"
                      >
                        {/* linkedInIcon */}
                        <img
                          src={linkedInIcon}
                          alt="Hirestar on linkedin "
                          loading="lazy"
                        />
                        {/* <LazyImage src={linkedInIcon} alt="Hirestar on linkedin " className={"linkedin-footer-icon"} /> */}
                      </a>
                    </li>

                    <li>
                      <a
                        title="Facebook"
                        aria-label="Visit HireStar.io Facebook Page"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="text-teal-700 transition hover:text-teal-700/75"
                        href="https://www.facebook.com/hirestario"
                      >
                        {/* facebook Icon */}
                        <img
                          src={facebookIcon}
                          alt="Hirestar on facebook"
                          loading="lazy"
                        />
                        {/* <LazyImage src={facebookIcon} alt="Hirestar on facebook" className={"facebook-footer-icon"} /> */}
                      </a>
                    </li>

                    {/* Twitter */}
                    <li>
                      <a
                        title="Twitter"
                        aria-label="Visit HireStar.io Twitter Page"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="text-teal-700 transition hover:text-teal-700/75"
                        href="https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09"
                      >
                        {/* Twitter Icon */}
                        <img
                          src={xIcon}
                          className="object-contain"
                          alt="Hirestar on x"
                          width="32"
                          height="33"
                          loading="lazy"
                        />

                        {/* <LazyImage src={xIcon} alt="Hirestar on x" className={"x-footer-icon"} /> */}
                      </a>
                    </li>
                    {/* Instagram */}
                    <li>
                      <a
                        title="Instagram"
                        aria-label="Visit HireStar.io Instagram Page"
                        href="https://www.instagram.com/hirestar.io/"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="text-teal-700  transition hover:text-teal-700/75"
                      >
                        <img
                          src={instagramIcon}
                          alt="Hirestar on instagram"
                          loading="lazy"
                        />
                        {/* <LazyImage src={instagramIcon} alt="Hirestar on instagram" className={"instagram-footer-icon"} /> */}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* links container */}
              <div className="grid  grid-cols-2 md:grid-cols-3  lg:col-span-2">
                <div className="  sm:text-left">
                  <p className="font-semibold  text-base text-[#FFFFFF]">
                    Useful Links
                  </p>

                  <ul className="mt-4 space-y-3 text-sm list-none  px-0">
                    <li>
                      <Link
                        to="/about-us"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all  hover:font-bold"
                      >
                        {/* <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                          // className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition  hover:text-white "
                          href="a"
                        > */}
                        About Us
                        {/* </a> */}
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/govt-api"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        {/* <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:font-bold hover:text-white"
                          href="a"
                        > */}
                        Government API
                        {/* </a> */}
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/blogs"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        {/* <a
                          className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition hover:font-bold hover:text-white"
                          href="a"
                        > */}
                        Blogs
                        {/* </a> */}
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/privacy-policy"
                        // target="_blank"
                        rel="noopener noreferrer"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/refund-policy"
                        // target="_blank"
                        rel="noopener noreferrer"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        Refund Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/terms-of-service"
                        // target="_blank"
                        rel="noopener noreferrer"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        Terms of Service
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="opacity-90  sm:text-left">
                  <p className="font-semibold text-base text-[#FFFFFF]">
                    Products
                  </p>

                  <ul className="mt-4 space-y-3 list-none text-sm px-0">
                    <li>
                      <Link
                        to="/self-verification"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        Self Verification
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/product/hr-portal"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        HR Portal
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/offer-portal"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        Offer experience
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/grievance-portal"
                        className="font-normal opacity-90 text-sm text-[rgb(255,255,255)] transition-all hover:font-bold"
                      >
                        Grievance Portal
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="sm:text-left mt-8 md:mt-0 lg:mt-0">
                  <p className="font-semibold text-base text-[#FFFFFF]">
                    Contact Us
                  </p>
                  <ul className="mt-4 space-y-3 text-sm px-0 list-none">
                    <li className="flex items-center   gap-2.5 ltr:sm:justify-start rtl:sm:justify-end">
                      {/* contactIcon */}
                      <img
                        src={contactIcon}
                        alt="Hirestar Contact Icon"
                        loading="lazy"
                      />
                      {/* <LazyImage src={contactIcon} alt="Hirestar Contact Icon" className={"contact-icon"} /> */}
                      <span className="font-normal opacity-90  text-sm text-[rgb(255,255,255)]">
                        +91 91441 01303
                      </span>
                    </li>

                    <li>
                      <Link className="flex items-center   gap-2.5 ltr:sm:justify-start rtl:sm:justify-end ">
                        {/* mailIcon */}
                        <img
                          src={mailIcon}
                          alt="Hirestar email id"
                          loading="lazy"
                        />
                        {/* <LazyImage src={mailIcon} alt="Hirestar email id" className={"mail-icon"} /> */}
                        <span className="font-normal opacity-90  text-sm text-[rgb(255,255,255)]">
                          admin@hirestar.io
                        </span>
                      </Link>
                    </li>

                    {/* 1st Location */}
                    <li className="flex items-start gap-2.5 ltr:sm:justify-start rtl:sm:justify-end">
                      <Link
                        to="#"
                        //  to={'https://www.google.com/maps/place/T-Hub+Phase+2/@17.4345506,78.3766436,697m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bcb93e37831f177:0x32d4499d34baaa78!8m2!3d17.4345506!4d78.3792185!16s%2Fg%2F11ddx33gc9?entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D'}
                        onClick={() =>
                          openInNewTab(
                            "https://www.google.com/maps/place/T-Hub+Phase+2/@17.4345506,78.3766436,697m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bcb93e37831f177:0x32d4499d34baaa78!8m2!3d17.4345506!4d78.3792185!16s%2Fg%2F11ddx33gc9?entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"
                          )
                        }
                        className="flex gap-2.5 ltr:sm:justify-start rtl:sm:justify-end"
                      >
                        {/* Location Icon */}
                        <img
                          src={locationIcon}
                          alt="Hirestar hydrabad address "
                          loading="lazy"
                        />
                        {/* <LazyImage src={locationIcon} alt="Hirestar hydrabad address " className={"hydrabad-location-icon"} /> */}

                        <p className="flex-1 font-normal opacity-90 text-sm text-[rgb(255,255,255)] font-poppins">
                          DappLogix Software Pvt Ltd, T-hub 2.0, Hyderabad,
                          India
                        </p>
                      </Link>
                    </li>

                    {/* 2nd Location */}
                    <li className="flex items-start gap-2.5 ltr:sm:justify-start rtl:sm:justify-end">
                      <Link
                        to="#"
                        // to="https://www.google.com/maps/place/91Springboard+Sector-2,+Noida/@28.5836595,77.3140347,641m/data=!3m2!1e3!4b1!4m6!3m5!1s0x390ce58e07e58aa1:0x32d5740a24aaf4b1!8m2!3d28.5836595!4d77.3166096!16s%2Fg%2F11gxtjf8qz?entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"
                        onClick={() =>
                          openInNewTab(
                            "https://www.google.com/maps/place/91Springboard+Sector-2,+Noida/@28.5836595,77.3140347,641m/data=!3m2!1e3!4b1!4m6!3m5!1s0x390ce58e07e58aa1:0x32d5740a24aaf4b1!8m2!3d28.5836595!4d77.3166096!16s%2Fg%2F11gxtjf8qz?entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"
                          )
                        }
                        className="flex gap-2.5 ltr:sm:justify-start rtl:sm:justify-end"
                      >
                        {/* Location Icon */}
                        <img
                          src={locationIcon}
                          alt="Hirestar noida address"
                          loading="lazy"
                        />
                        {/* <LazyImage src={locationIcon} alt="Hirestar noida address" className={"noida-location-icon"} /> */}

                        <p className="flex-1 font-normal opacity-90 text-sm text-[rgb(255,255,255)] font-poppins">
                          DappLogix Software Pvt Ltd, 91 springboard, Sector 2,
                          Noida (Delhi-NCR), India
                        </p>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className=" border-t border-gray-100">
            <div className=" text-center py-4">
              <p className="text-sm  text-white  sm:mt-0">
                © Copyright Hirestar.io ® Registered trademark of DappLogix
                Software Pvt Ltd - All Rights reserved 2025
              </p>
              <p className="text-sm  text-white  sm:mt-0">
                Version: {packageInfo.version}
              </p>
            </div>
          </div>
        </div>
        {/* -----------------------Copyright Section------------------------------------ */}
      </footer>
    </div>
  );
}
